// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {
	$(document).ready(function () {
		var placeholder = $('#booking-form .group-code input').attr('placeholder');
		$(' #booking-form .group-code input ').on('click', function () {
			$(this).attr('placeholder', '');
		});
		// ACCOMMODATIONS FILTER
		document.querySelectorAll('.rooms_filter button').forEach((btn, i) => {
			btn.addEventListener('click', (_) => {
				$('.room sym_slides').slick('unslick');

				document.querySelectorAll('.rooms_filter button').forEach((b) => {
					b.classList.remove('active');
					b.setAttribute('aria-selected','false');
				});
				btn.setAttribute('aria-selected','true');
				btn.classList.add('active');

				document.querySelectorAll('.room').forEach((room) => {
					room.classList.remove('active', 'imgRight');
					if (btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag) {
						room.classList.add('active');
					}
				});

				document.querySelectorAll('.room.active').forEach((activeRoom, j) => {
					if (j % 2 === 0) {
						activeRoom.classList.add('imgRight');
					}
				});

				$('.room sym_slides').slick();
			});

			if (i === 0) btn.click();
		});

		//Call function with browser is resized.
		$(window).resize(function (event) {
			//
		});

		// TABLET TOGGLE NAV
		document.querySelectorAll('.js-toggleNav').forEach((btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				btn.classList.toggle('active');
				document.querySelector(e.currentTarget.getAttribute('href')).classList.toggle('active');
			});
		});

		// Main Nav Dropdown
		$('#primary-nav li').hover(
			function () {
				$(this).addClass('hover');
				$('ul.submenu', this).fadeIn(200);
			},
			function () {
				$(this).removeClass('hover');
				$('ul.submenu', this).fadeOut(200);
			}
		);

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];

		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if ((d1 && date.getTime() == d1.getTime()) || (d2 && date.getTime() == d2.getTime())) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		function decorateUrl(urlString) {
			var ga = window[window['GoogleAnalyticsObject']];
			var tracker;
			if (ga && typeof ga.getAll === 'function') {
				tracker = ga.getAll()[0]; // Uses the first tracker created on the page
				urlString = new window.gaplugins.Linker(tracker).decorate(urlString);
			}
			return urlString;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = $('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format') ? $('#CheckIn').data('format') : 'yy-mm-dd';
		$('#CheckIn').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$('#CheckOut').datepicker('setDate', newDate);
				$('#CheckOut').datepicker('option', 'minDate', selectedDate);
			},
		});
		$('#CheckOut').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			},
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
	});

	window.onload = function () {
		/*this function add a class to header when scroll down the page
        /* and change the logo by a new file if needed depending of mockup
        */

		// scrollDownAction(20, 'scroll');

		// INNER PAGES HEADER SPACE
		if (document.getElementById('start-content')) {
			document.getElementById('start-content').style.paddingTop = `${document.getElementById('header').offsetHeight}px`;
		}

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		});
	};
})();

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
